import React from 'react';
import cn from 'classnames';

import { DatePicker as AntDatePicker } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';
import { MinusIcon, CalendarIcon } from '@revfluence/fresh-icons/regular';

import styles from './DatePicker.module.scss';

/**
 * RangePicker component
 */
export const RangePicker: React.FC<RangePickerProps> = ({
  className,
  ...props
}) => {
  const { separator = <MinusIcon />, suffixIcon = <CalendarIcon /> } = props;
  return (
    <AntDatePicker.RangePicker
      className={cn(styles.DatePicker, className)}
      suffixIcon={suffixIcon}
      separator={separator}
      {...props}
    />
  );
};
